import { render, staticRenderFns } from "./CartPreview.vue?vue&type=template&id=062ec6fb&scoped=true"
import script from "./CartPreview.vue?vue&type=script&lang=ts"
export * from "./CartPreview.vue?vue&type=script&lang=ts"
import style0 from "./CartPreview.vue?vue&type=style&index=0&id=062ec6fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062ec6fb",
  null
  
)

export default component.exports